import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(`
    Missing Supabase configuration!
    
    Please create a .env file in your project root with:
    REACT_APP_SUPABASE_URL=your_supabase_project_url
    REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key
    
    Get these values from your Supabase project dashboard > Settings > API
  `);
}

// Validate URL format
try {
  new URL(supabaseUrl);
} catch (error) {
  throw new Error(`
    Invalid Supabase URL format!
    
    Your URL should look like: https://your-project-id.supabase.co
    Current URL: ${supabaseUrl}
  `);
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database table names
export const TABLES = {
  RACES: 'races',
  RUNNERS: 'runners',
  PROFILES: 'profiles'
} as const;
